import { LiveSearchApiWrapper, LiveSearchApiWrapperProps } from './wrapper/LiveSearchWrapper';
import { Clients } from '../../framework/openapi';
import { Text, theme, useIptorTranslation } from '@iptor/base';

export type LiveSearchItemsProps = Omit<
  LiveSearchApiWrapperProps<'internal.v1.base-inventory', 'GET /items'>,
  'apiClient' | 'apiFunction' | 'columnKey'
>;

export const LiveSearchItems = ({ columnIds, ...props }: LiveSearchItemsProps) => {
  const { t } = useIptorTranslation();

  return (
    <>
      <LiveSearchApiWrapper
        {...props} // needs to be on the beginning to not override specified below props for the defaults
        apiClient={Clients.Internal.Base.V1.Inventory}
        apiFunction={'GET /items'}
        columnKey={'item'}
        columnIds={columnIds ? columnIds : ['item', 'description', 'internalName']}
      />
      <Text
        sx={{ display: 'flex', justifyContent: 'flex-end' }}
        fontSize={'12px'}
        color={theme?.palette?.foreground?.[600]}
      >
        {t('common:TXT_Pro_Tip_Press_F4')}
      </Text>
    </>
  );
};
